import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';
import { SvgIcon } from '@adsk/bim360-matrix-react-components';
import Zoomable from './components/Zoomable';
import Modal from './components/Modal';

import USWorkFlowSvg from '../USWorkFlowSvg';
import EUWorkFlowSvg from '../EUWorkFlowSvg';

import USImgLarge from '../../../../assets/images/workflows/workflow_A.svg';
import EUImgLarge from '../../../../assets/images/workflows/workflow_B.svg';

import { WORKFLOW_A, WORKFLOW_B } from '../../../../constants/roles-types';
import { objectType } from '../../../../constants/proptype-validation';

class WorkflowsModal extends PureComponent {
  static displayName = 'WorkflowsModal';

  static propTypes = {
    setModalVisible: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    openAsZoomable: PropTypes.bool,
    presets: objectType,
    createWorkflow: PropTypes.func,
    currentType: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.state = {};
  }

  close() {
    const modalOpen = false;

    this.props.setModalVisible({ modalOpen });
  }

  _header() {
    return (
      <Modal.Header>
        <Modal.CloseButton
          setIsOpen={(isOpen) => {
            this.props.setModalVisible({ modalOpen: isOpen });
          }}
        />
        <div className="title">
          {this.props.openAsZoomable
            ? this.props.presets[this.props.currentType].name
            : T.translate('adminWorkflow.selectWorkflow')}
        </div>
        <div className="subtitle" />
      </Modal.Header>
    );
  }

  create(attributes) {
    if (this.props.currentType === this.state.selected) {
      return;
    }

    this.props.createWorkflow(
      this.state.selected ? this.state.selected : this.props.currentType,
      attributes
    );
  }

  renderWorkflowImage(type) {
    if (type.key === WORKFLOW_B) {
      return <EUWorkFlowSvg />;
    }
    return <USWorkFlowSvg />;
  }

  _type(type) {
    const selected = type.key === this.props.currentType;

    return (
      <label htmlFor={`workflow-${type.key}`} key={type.key}>
        <div className="box">
          <div className="row">
            <div className="col-1" style={{ textAlign: 'center' }}>
              <input
                type="radio"
                id={`workflow-${type.key}`}
                name="workflow"
                value={type.key}
                defaultChecked={selected}
                className="radio"
                onChange={(e) => {
                  this.setState({ selected: e.target.value });
                }}
              />
            </div>
            <div className="col-4">
              <div className="title">
                {type.name}
                {type.key === WORKFLOW_A ? (
                  <div className="default-icon">{T.translate('adminWorkflow.defaultCapital')}</div>
                ) : null}
              </div>
              <div className="subtitle">{type.description}</div>
            </div>
            <div className="col-7 center-vertically">{this.renderWorkflowImage(type)}</div>
          </div>
        </div>
      </label>
    );
  }

  _content() {
    if (!this.props.open) {
      return;
    }
    const types = [];
    let imgType = USImgLarge;

    // eslint-disable-next-line no-restricted-syntax
    for (const key in this.props.presets) {
      types.push(
        this._type({
          ...this.props.presets[key],
          key,
        })
      );
    }

    if (this.props.currentType === WORKFLOW_B) {
      imgType = EUImgLarge;
    }

    // eslint-disable-next-line consistent-return
    return (
      <Modal.Body removeBodyEdges={this.props.openAsZoomable}>
        {this.props.openAsZoomable ? <Zoomable img={imgType} /> : types}
      </Modal.Body>
    );
  }

  apply() {
    this.create({ title: 'untitled' });
    this.close();
  }

  _controls() {
    if (this.props.openAsZoomable) {
      return null;
    }

    return (
      <div className="clearfix">
        <div
          className="ok-btn"
          onClick={() => {
            this.apply();
          }}
        >
          {T.translate('navigation.apply')}
        </div>
        <div className="cancel-btn" onClick={() => this.close()}>
          {T.translate('navigation.cancel')}
        </div>
      </div>
    );
  }

  _footer() {
    return <Modal.Footer>{this._controls()}</Modal.Footer>;
  }

  render() {
    return (
      <Modal
        setIsOpen={(isOpen) => {
          this.props.setModalVisible({ modalOpen: isOpen });
        }}
        isOpen={this.props.open}
        className="workflows-modal-container"
      >
        {this._header()}
        {this._content()}
        {this._footer()}
      </Modal>
    );
  }
}

export default WorkflowsModal;
